import React from "react";
import logo from "../../resources/evangadi-logo-footer.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Footer.css";

const Footer = () => {
    return (
        <footer>
            <div className="container pt-5">
                <div className="row">
                    <div className="col-12 col-md-4">
                        <img src={logo} />
                    </div>
                    <div className="col-12 col-md-4">
                        <h3>Useful Link</h3>
                        <ul>
                            <li>How it works</li>
                            <li>Terms of Service</li>
                            <li>Privacy policy</li>
                        </ul>
                    </div>
                    <div className="col-12 col-md-4">
                        <h3>Contact Info</h3>
                        <ul>
                            <li>Evangadi Networks</li>
                            <li>support@evangadi.com</li>
                            <li>+1-202-386-2702</li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
